import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeEntity, changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    CHANNABLEFEED_RECEIVE_LIST: receiveList,
    CHANNABLEFEED_CHANGE_FILTER: changeFilter,
    CHANGE_ENTITY_CHANNABLEFEED: changeEntity,
    INVALIDATE_CHANNABLEFEED: invalidateFilters,
    CHANNABLEFEED_REQUEST: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    counts: {},
    entities: {},
    result: {},
    filters: {},
}

export default createReducer(initialState, handlers)
